import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f1b9914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "modal-title" }, " Change parents ", -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Select which parent to change: ", -1))
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = ["disabled"]

import { computed, ref } from 'vue'
import { FamilyRelationshipRole, ViewFamily } from '@/rd/ResearchDataModel'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { ProfileUtils } from './ProfileUtils'
import { Modal } from 'bootstrap'
import PersonCard from '@/manage/PersonCard.vue'
import { hideModalAsync } from '@/util/AppUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileParentRelationshipModal',
  emits: ["change", "remove"],
  setup(__props, { expose: __expose, emit }) {



__expose({
  open,
})

const parentRoles = [
  { role: FamilyRelationshipRole.Father, label: "Father" },
  { role: FamilyRelationshipRole.Mother, label: "Mother" },
]

const childIdRef = ref<string>()
const parentFamilyRef = ref<ViewFamily>()
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()

const viewPersonStore = useViewPersonStore()
const dataGroupStore = useDataGroupStore()

const viewPersonRef = computed(() => viewPersonStore.getLoadedPerson(childIdRef.value))
const profileIdsRef = computed(() => {
  if (!viewPersonRef.value)
    return []
  const matchDataGroups = dataGroupStore.getLoadedGroupList(viewPersonRef.value?.groupIds)
  return ProfileUtils.getNonPlaceholderIds(viewPersonRef.value.matchIds, matchDataGroups)
})

function open(childId: string, parentFamily: ViewFamily) {
  if (modalRef.value) {
    childIdRef.value = childId
    parentFamilyRef.value = parentFamily
    Modal.getOrCreateInstance(modalRef.value)?.show()
  }
}

function getSpouseId(role: FamilyRelationshipRole) {
  return parentFamilyRef.value?.getSpouseId(role)
}

async function onChange(role: FamilyRelationshipRole, remove = false) {
  if (modalRef.value) {
    await hideModalAsync(modalRef.value) // async so another modal can open immediately after
    if (remove)
      emit('remove', role)
    else
      emit('change', role)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    ref_key: "modalRef",
    ref: modalRef,
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", _mergeProps({
            type: "button",
            class: "btn-close"
          }, { disabled: busyRef.value }, {
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }), null, 16)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(parentRoles, (r) => {
            return _createElementVNode("div", {
              key: r.role,
              class: "parent"
            }, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(r.label), 1),
              _createVNode(PersonCard, {
                "person-id": getSpouseId(r.role),
                layout: "small",
                "show-profile-type": "",
                "show-profile-count": "multiple",
                static: ""
              }, null, 8, ["person-id"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-inline btn-link btn-sm",
                  onClick: ($event: any) => (onChange(r.role))
                }, " Change ", 8, _hoisted_9),
                (getSpouseId(r.role))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-inline btn-link",
                      onClick: ($event: any) => (onChange(r.role, true))
                    }, " Remove ", 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal"
          }, " Done ", 8, _hoisted_12)
        ])
      ])
    ])
  ], 512))
}
}

})